import { useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '~/utils/trpc'

export const useInvalidateMaterialReturns = () => {
  const trpc = useTRPC()
  const queryClient = useQueryClient()

  return (installationIds: number[]) => {
    queryClient.invalidateQueries({ queryKey: trpc.ops.materialReturns.pathKey() })
    installationIds.forEach((installationId) =>
      queryClient.invalidateQueries({
        queryKey: trpc.ops.stationInstallations.events.list.queryKey({ installationId })
      })
    )
  }
}
